var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGridIconSmall = function SvgGridIconSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_168",
    "data-name": "Group 168",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.002,
    height: 18.001,
    viewBox: "0 0 32.002 18.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M655.806,520.484h-31v-17h31Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M625.3,503.983v16h30v-16h-30m-1-1h32v18h-32Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M626.265,514.984h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-2",
    "data-name": "Grey Box-2",
    d: "M626.266,509.984h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-3",
    "data-name": "Grey Box-3",
    d: "M626.265,504.982h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-4",
    "data-name": "Grey Box-4",
    d: "M635.966,514.984h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-5",
    "data-name": "Grey Box-5",
    d: "M635.968,509.984h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-6",
    "data-name": "Grey Box-6",
    d: "M635.966,504.982h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-7",
    "data-name": "Grey Box-7",
    d: "M645.666,514.984h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-8",
    "data-name": "Grey Box-8",
    d: "M645.667,509.984h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-9",
    "data-name": "Grey Box-9",
    d: "M645.666,504.982h8.682v4.03h-8.682Z",
    transform: "translate(-624.304 -502.983)",
    fill: "#024"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGridIconSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grid-icon-small.2ac76dade38f248f0960ce971d8ae894.svg";